import { render, staticRenderFns } from "./AirResistanceViz.vue?vue&type=template&id=0d7c6b4d&scoped=true"
import script from "./AirResistanceViz.vue?vue&type=script&lang=js"
export * from "./AirResistanceViz.vue?vue&type=script&lang=js"
import style0 from "./AirResistanceViz.vue?vue&type=style&index=0&id=0d7c6b4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c6b4d",
  null
  
)

export default component.exports